import React, { useEffect, useState } from 'react';
import axios from 'axios'
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';
import { Button } from 'bootstrap';

const useDailogStyles = makeStyles((theme) => ({
    text: {
        color: '#222'
    },
    dailogbutton: {
        color: '#fff'
    },
    uploadedImg: {
        height: '100px',
        paddingLeft: '20px'
    }
}));

const headCells = [
    { id: 'name', label: 'Name' },
    { id: 'city', label: 'City' },
    { id: 'gender', label: 'Gender' },
    { id: 'age', label: 'Age' },
    { id: 'mobile', label: 'Mobile' },
    { id: 'travel', label: 'Travel Preference' },
    { id: 'anyMedicalIssue', label: 'Medical Issue' },
    { id: 'payment_status', label: 'Payment Status' },
    { id: 'razorpay_payment_id', label: 'Razorpay Payment Id' },
    { id: 'time_stamp', label: 'Time of registration' },
    { id: 'identity', label: 'Id Image' },
    { id: 'email', label: 'Email' },
    { id: 'pan', label: 'Pan' }
];

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
        boxShadow: 'none'
    },
    table: {
        minWidth: 500,
        marginTop: '50px'
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    checkboxcolor: {
        color: '#222',
        '&$checked': {
            color: '#222',
        },
    },
    fab: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: '90px',
        zIndex: 1000
    },
    fab2: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: '20px',
        zIndex: 1000
    }
}));

export default function EnhancedTable(props) {
    const classes = useStyles();
    const [rows, setRows] = useState([])
    const [loading, setloading] = useState(true);

    useEffect(() => {
        let textData;
        axios.get('https://satprerna.org/satprerna_backend/home/get_from_parikrama_2024.php').then(response => {
            textData = response.data;
            setRows(textData);
            setloading(false);
        })
            .catch(error => {
                console.log(error);
            });
    }, []);

    if (loading)
        return <CircularProgress style={{ color: '#9a0808' }} />
    else return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <Typography align="center" className={classes.title} variant="h3" id="tableTitle" component="div">
                    Narmada Parikrama 2024
                </Typography>
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size='medium'
                        aria-label="enhanced table"
                    >
                        <TableHead>
                            <TableRow>
                                {headCells.map((headCell) => (
                                    <TableCell
                                        key={headCell.id}
                                        align='left'
                                        padding='default'
                                    >
                                        <b>{headCell.label}</b>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows
                                .map((row, index) => {
                                    return (
                                        <TableRow hover tabIndex={-1} key={row.id}>
                                            {/* <TableCell align="left" component="th" scope="row" padding="none">
                                                {row.id}
                                            </TableCell> */}
                                            <TableCell align="left">{row.name}</TableCell>
                                            <TableCell align="left">{row.city}</TableCell>
                                            <TableCell align="left">{row.gender}</TableCell>
                                            <TableCell align="left">{row.age}</TableCell>
                                            <TableCell align="left">{row.mobile}</TableCell>
                                            <TableCell align="left">{row.travel}</TableCell>
                                            <TableCell align="left">{row.anyMedicalIssue}</TableCell>
                                            <TableCell align="left">{row.payment_status}</TableCell>
                                            <TableCell align="left">{row.razorpay_payment_id}</TableCell>
                                            <TableCell align="left">{row.time_stamp}</TableCell>
                                            <TableCell align="left"><a href={"https://satprerna.org/satprerna_backend/home/get_identity_image_from_parikrama_2024.php?id=" + row.id} target='_blank'>View Image</a></TableCell>
                                            <TableCell align="left">{row.email}</TableCell>
                                            <TableCell align="left">{row.pan}</TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </div>
    );
}
